import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconRadio.module.css';

const IconRadio = props => {
  const { isChecked } = props;
  const classes = classNames(css.root, {[css.checked]: isChecked});

  return (
    <svg className={classes} width="14" height="14" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="5"
        cy="19"
        r="6"
        transform="translate(2 -12)"
        strokeWidth="2"
        fill="none"
        fillRule="evenodd"
      />

      <g
        transform="translate(2 -12)"
        fill="none"
        fillRule="evenodd"
      >
        <circle strokeWidth="2" cx="5" cy="19" r="6" />
        <circle fill="#FFF" fillRule="nonzero" cx="5" cy="19" r="3" />
      </g>
    </svg>
  );
};

IconRadio.defaultProps = {
  className: null,
  rootClassName: null,
};

IconRadio.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconRadio;
